module.exports = __webpack_public_path__ + "static/media/353.df29e11b.svg";